export default {
  className: 'AdiCm.LocalParts',
  data: {
    description: 'LTC Parts',
    en: [
      {
        id: 'row1',
        0: {
          regionRecommend: 0,
          rookiePart: 0,
          dataSheet: 0,
          description: 'Precision Operational Amplifier',
          usedInCFTL: 0,
          hasAnEvalBoard: 0,
          evalBoardUrl: '',
          generic: 'lt1001',
          displayValue: 'LT1001',
          value: ['LT1001'],
          genericStatus: 'Production',
          package: ['8 ld SOIC'],
        },
        '-1': {
          usedInCFTL: 0,
          hasAnEvalBoard: 0,
          evalBoardURL: '',
        },
        '-2': {
          value: ['Production'],
          displayValue: 'Production',
        },
        '-3': {
          value: ['8 ld SOIC'],
          displayValue: '8 ld SOIC',
        },
        '-4': {
          value: ['Precision Operational Amplifier'],
          displayValue: 'Precision Operational Amplifier',
        },
        2687: {
          value: ['1'],
          displayValue: '1',
        },
        4501: {
          value: ['0.000025'],
          displayValue: '25µ',
        },
        300: {
          value: ['0.25'],
          displayValue: '0.25',
        },
        2839: {
          value: ['6'],
          displayValue: '6',
        },
        2840: {
          value: ['44'],
          displayValue: '44',
        },
        4108: {
          value: ['0.0015'],
          displayValue: '1.5m',
        },
        5056: {
          value: ['Voltage Feedback'],
          displayValue: 'Voltage Feedback',
        },
        4101: {
          value: ['0.0000000096'],
          displayValue: '9.6n',
        },
        4124: {
          value: ['0.0000000000001'],
          displayValue: '100f',
        },
        4500: {
          value: ['0.000000002'],
          displayValue: '2n',
        },
        4127: {
          value: ['1'],
          displayValue: '1',
        },
        4100: {
          value: ['1'],
          displayValue: '1',
        },
        4099: {
          value: ['1'],
          displayValue: '1',
        },
        4084: {
          value: ['0.9'],
          displayValue: '0.9',
        },
        4085: {
          value: ['0.9'],
          displayValue: '0.9',
        },
        4502: {
          value: ['800000'],
          displayValue: '800k',
        },
        4401: {
          value: ['50'],
          displayValue: '50',
        },
        4455: {
          value: [],
          displayValue: '',
        },
        4117: {
          value: [],
          displayValue: '',
        },
        s1: {
          value: ['19873'],
          displayValue: '19873',
        },
        s2: {
          value: [''],
          displayValue: '',
        },
        s3: {
          value: ['1.65'],
          displayValue: '$1.65',
        },
        s4: {
          value: ['R-8'],
          displayValue: 'R-8',
        },
        s5: {
          value: ['8 ld SOIC'],
          displayValue: '8 ld SOIC',
        },
        s6: {
          value: ['Precision Operational Amplifier'],
          displayValue: 'Precision Operational Amplifier',
        },
        s7: {
          value: ['Production'],
          displayValue: 'Production',
        },
        s8: {
          value: [''],
          displayValue: '',
        },
        s9: {
          value: [],
          displayValue: '',
        },
        s10: {
          value: [],
          displayValue: '',
        },
        s11: {
          value: ['3'],
          displayValue: '3',
        },
        s12: {
          value: [],
          displayValue: '',
        },
      },
    ],
    jp: [
      {
        id: 'row1',
        0: {
          regionRecommend: 0,
          rookiePart: 0,
          dataSheet: 0,
          description: '高精度オペアンプ',
          usedInCFTL: 0,
          hasAnEvalBoard: 0,
          evalBoardUrl: '',
          generic: 'lt1001',
          displayValue: 'LT1001',
          value: ['LT1001'],
          genericStatus: '生産／供給中',
          package: ['8 ld SOIC'],
        },
        '-1': {
          usedInCFTL: 0,
          hasAnEvalBoard: 0,
          evalBoardURL: '',
        },
        '-2': {
          value: ['生産／供給中'],
          displayValue: '生産／供給中',
        },
        '-3': {
          value: ['8 ld SOIC'],
          displayValue: '8 ld SOIC',
        },
        '-4': {
          value: ['高精度オペアンプ'],
          displayValue: '高精度オペアンプ',
        },
        2687: {
          value: ['1'],
          displayValue: '1',
        },
        4501: {
          value: ['0.000025'],
          displayValue: '25µ',
        },
        300: {
          value: ['0.25'],
          displayValue: '0.25',
        },
        2839: {
          value: ['6'],
          displayValue: '6',
        },
        2840: {
          value: ['44'],
          displayValue: '44',
        },
        4108: {
          value: ['0.0015'],
          displayValue: '1.5m',
        },
        5056: {
          value: ['Voltage Feedback'],
          displayValue: 'Voltage Feedback',
        },
        4101: {
          value: ['0.0000000096'],
          displayValue: '9.6n',
        },
        4124: {
          value: ['0.0000000000001'],
          displayValue: '100f',
        },
        4500: {
          value: ['0.000000002'],
          displayValue: '2n',
        },
        4127: {
          value: ['1'],
          displayValue: '1',
        },
        4100: {
          value: ['1'],
          displayValue: '1',
        },
        4099: {
          value: ['1'],
          displayValue: '1',
        },
        4084: {
          value: ['0.9'],
          displayValue: '0.9',
        },
        4085: {
          value: ['0.9'],
          displayValue: '0.9',
        },
        4502: {
          value: ['800000'],
          displayValue: '800k',
        },
        4401: {
          value: ['50'],
          displayValue: '50',
        },
        4455: {
          value: [],
          displayValue: '',
        },
        4117: {
          value: [],
          displayValue: '',
        },
        s1: {
          value: ['19873'],
          displayValue: '19873',
        },
        s2: {
          value: [''],
          displayValue: '',
        },
        s3: {
          value: ['1.65'],
          displayValue: '$1.65',
        },
        s4: {
          value: ['R-8'],
          displayValue: 'R-8',
        },
        s5: {
          value: ['8 ld SOIC'],
          displayValue: '8 ld SOIC',
        },
        s6: {
          value: ['高精度オペアンプ'],
          displayValue: '高精度オペアンプ',
        },
        s7: {
          value: ['生産／供給中'],
          displayValue: '生産／供給中',
        },
        s8: {
          value: [''],
          displayValue: '',
        },
        s9: {
          value: [],
          displayValue: '',
        },
        s10: {
          value: [],
          displayValue: '',
        },
        s11: {
          value: ['3'],
          displayValue: '3',
        },
        s12: {
          value: [],
          displayValue: '',
        },
      },
    ],
    cn: [
      {
        id: 'row1',
        0: {
          regionRecommend: 0,
          rookiePart: 0,
          dataSheet: 0,
          description: '高精度运算放大器',
          usedInCFTL: 0,
          hasAnEvalBoard: 0,
          evalBoardUrl: '',
          generic: 'lt1001',
          displayValue: 'LT1001',
          value: ['LT1001'],
          genericStatus: '量产',
          package: ['8 ld SOIC'],
        },
        '-1': {
          usedInCFTL: 0,
          hasAnEvalBoard: 0,
          evalBoardURL: '',
        },
        '-2': {
          value: ['量产'],
          displayValue: '量产',
        },
        '-3': {
          value: ['8 ld SOIC'],
          displayValue: '8 ld SOIC',
        },
        '-4': {
          value: ['高精度运算放大器'],
          displayValue: '高精度运算放大器',
        },
        2687: {
          value: ['1'],
          displayValue: '1',
        },
        4501: {
          value: ['0.000025'],
          displayValue: '25µ',
        },
        300: {
          value: ['0.25'],
          displayValue: '0.25',
        },
        2839: {
          value: ['6'],
          displayValue: '6',
        },
        2840: {
          value: ['44'],
          displayValue: '44',
        },
        4108: {
          value: ['0.0015'],
          displayValue: '1.5m',
        },
        5056: {
          value: ['Voltage Feedback'],
          displayValue: 'Voltage Feedback',
        },
        4101: {
          value: ['0.0000000096'],
          displayValue: '9.6n',
        },
        4124: {
          value: ['0.0000000000001'],
          displayValue: '100f',
        },
        4500: {
          value: ['0.000000002'],
          displayValue: '2n',
        },
        4127: {
          value: ['1'],
          displayValue: '1',
        },
        4100: {
          value: ['1'],
          displayValue: '1',
        },
        4099: {
          value: ['1'],
          displayValue: '1',
        },
        4084: {
          value: ['0.9'],
          displayValue: '0.9',
        },
        4085: {
          value: ['0.9'],
          displayValue: '0.9',
        },
        4502: {
          value: ['800000'],
          displayValue: '800k',
        },
        4401: {
          value: ['50'],
          displayValue: '50',
        },
        4455: {
          value: [],
          displayValue: '',
        },
        4117: {
          value: [],
          displayValue: '',
        },
        s1: {
          value: ['19873'],
          displayValue: '19873',
        },
        s2: {
          value: [''],
          displayValue: '',
        },
        s3: {
          value: ['1.65'],
          displayValue: '$1.65',
        },
        s4: {
          value: ['R-8'],
          displayValue: 'R-8',
        },
        s5: {
          value: ['8 ld SOIC'],
          displayValue: '8 ld SOIC',
        },
        s6: {
          value: ['高精度运算放大器'],
          displayValue: '高精度运算放大器',
        },
        s7: {
          value: ['量产'],
          displayValue: '量产',
        },
        s8: {
          value: [''],
          displayValue: '',
        },
        s9: {
          value: [],
          displayValue: '',
        },
        s10: {
          value: [],
          displayValue: '',
        },
        s11: {
          value: ['3'],
          displayValue: '3',
        },
        s12: {
          value: [],
          displayValue: '',
        },
      },
    ],
    ru: [
      {
        id: 'row1',
        0: {
          regionRecommend: 0,
          rookiePart: 0,
          dataSheet: 0,
          description: 'Precision Operational Amplifier',
          usedInCFTL: 0,
          hasAnEvalBoard: 0,
          evalBoardUrl: '',
          generic: 'lt1001',
          displayValue: 'LT1001',
          value: ['LT1001'],
          genericStatus: 'Production',
          package: ['8 ld SOIC'],
        },
        '-1': {
          usedInCFTL: 0,
          hasAnEvalBoard: 0,
          evalBoardURL: '',
        },
        '-2': {
          value: ['Production'],
          displayValue: 'Production',
        },
        '-3': {
          value: ['8 ld SOIC'],
          displayValue: '8 ld SOIC',
        },
        '-4': {
          value: ['Precision Operational Amplifier'],
          displayValue: 'Precision Operational Amplifier',
        },
        2687: {
          value: ['1'],
          displayValue: '1',
        },
        4501: {
          value: ['0.000025'],
          displayValue: '25µ',
        },
        300: {
          value: ['0.25'],
          displayValue: '0.25',
        },
        2839: {
          value: ['6'],
          displayValue: '6',
        },
        2840: {
          value: ['44'],
          displayValue: '44',
        },
        4108: {
          value: ['0.0015'],
          displayValue: '1.5m',
        },
        5056: {
          value: ['Voltage Feedback'],
          displayValue: 'Voltage Feedback',
        },
        4101: {
          value: ['0.0000000096'],
          displayValue: '9.6n',
        },
        4124: {
          value: ['0.0000000000001'],
          displayValue: '100f',
        },
        4500: {
          value: ['0.000000002'],
          displayValue: '2n',
        },
        4127: {
          value: ['1'],
          displayValue: '1',
        },
        4100: {
          value: ['1'],
          displayValue: '1',
        },
        4099: {
          value: ['1'],
          displayValue: '1',
        },
        4084: {
          value: ['0.9'],
          displayValue: '0.9',
        },
        4085: {
          value: ['0.9'],
          displayValue: '0.9',
        },
        4502: {
          value: ['800000'],
          displayValue: '800k',
        },
        4401: {
          value: ['50'],
          displayValue: '50',
        },
        4455: {
          value: [],
          displayValue: '',
        },
        4117: {
          value: [],
          displayValue: '',
        },
        s1: {
          value: ['19873'],
          displayValue: '19873',
        },
        s2: {
          value: [''],
          displayValue: '',
        },
        s3: {
          value: ['1.65'],
          displayValue: '$1.65',
        },
        s4: {
          value: ['R-8'],
          displayValue: 'R-8',
        },
        s5: {
          value: ['8 ld SOIC'],
          displayValue: '8 ld SOIC',
        },
        s6: {
          value: ['Precision Operational Amplifier'],
          displayValue: 'Precision Operational Amplifier',
        },
        s7: {
          value: ['Production'],
          displayValue: 'Production',
        },
        s8: {
          value: [''],
          displayValue: '',
        },
        s9: {
          value: [],
          displayValue: '',
        },
        s10: {
          value: [],
          displayValue: '',
        },
        s11: {
          value: ['3'],
          displayValue: '3',
        },
        s12: {
          value: [],
          displayValue: '',
        },
      },
    ],
  },
};
